<script>
    import TwitchImage from '../statics/twitch.svg'
    import { applicationConfigStore } from '../stores/applicationConfigStore'

    let redirectUrl
    applicationConfigStore.subscribe((store) => {
        redirectUrl = store.redirectUrl
    })
    async function openLink() {
        window.location.href = redirectUrl
    }
</script>

<div
    class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full">
        <div>
            <TwitchImage class="mx-auto h-12 w-auto" width="25" height="25" />
            <h2
                class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
                Sign in with your Twitch Account
            </h2>
        </div>
        <div class="mt-6">
            <button
                type="button"
                on:click={openLink}
                class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-purple-500 hover:bg-purple-300 focus:outline-none focus:border-purple-700 focus:shadow-outline-purple active:bg-purple-700 transition duration-150 ease-in-out">
                <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                    <svg
                        class="h-5 w-5 text-white-500 group-hover:text-white-400 transition ease-in-out duration-150"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            fill-rule="evenodd"
                            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                            clip-rule="evenodd" />
                    </svg>
                </span>
                Sign in
            </button>
        </div>
    </div>
</div>
